import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { inputCls, btnPrimary, Field } from "@/components/Modal";

const HERO_IMG = "https://images.unsplash.com/photo-1548741487-18d363dc4469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxhcnRpc2FuYWwlMjBjaG9jb2xhdGUlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzg0NzkzNzQ2fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#FDFBF7]" data-testid="login-page">
      <div className="hidden lg:block w-1/2 relative">
        <img src={HERO_IMG} alt="Artisanal chocolates" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2A1810]/60" />
        <div className="absolute bottom-12 left-12 right-12 text-[#FDFBF7]">
          <div className="font-display text-3xl font-bold leading-snug">Where every batch<br />becomes a story.</div>
          <p className="mt-3 text-sm text-[#EADCD0]/80">The internal operating system for Smoor's research & development kitchen.</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-lg bg-[#2A1810] flex items-center justify-center font-display font-bold text-[#C5A059] text-xl">S</div>
            <div>
              <div className="font-display text-xl font-bold text-[#1C100B]">Smoor R&D OS</div>
              <div className="text-xs text-[#8C7A6B]">Research & Development Portal</div>
            </div>
          </div>
          <h1 className="font-display text-2xl font-bold text-[#1C100B] mb-1">Welcome back</h1>
          <p className="text-sm text-[#8C7A6B] mb-6">Sign in with your team account.</p>
          {error && (
            <div className="mb-4 bg-[#FEF2F2] border border-[#FECACA] text-[#B91C1C] text-sm rounded-lg px-4 py-2.5" data-testid="login-error">
              {error}
            </div>
          )}
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <Field label="Email">
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@smoor.com" />
            </Field>
            <Field label="Password">
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
            </Field>
            <button data-testid="login-submit-button" type="submit" disabled={loading} className={`${btnPrimary} w-full justify-center`}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="text-sm text-[#8C7A6B] mt-6 text-center" data-testid="login-help">
            Accounts are provisioned by your workspace administrator.
          </p>
        </div>
      </div>
    </div>
  );
}
